import { CountryData } from "react-phone-input-2"
import { useGetPhoneNumberAvailableLazyQuery, useSendVerifyPhoneOtpMutation } from "../../../graphql/generated/graphql"
import { PhoneNumberInput } from "../../formElements/phoneInput"
import React, { Dispatch, SetStateAction, useState } from "react"
import { validatePhoneNumberAvailability } from "../../../utils/validations"
import { useTranslation } from "next-i18next"
import { Button } from "../../formElements/button"
import tw from "twin.macro"
import ReactGA from "react-ga"
import { JoinStep } from "."
import { useDebounce } from "../../../utils/hooks/useDebounce"

interface PhoneSignUpProp {
  setJoinStep: Dispatch<SetStateAction<JoinStep>>
  setSignUpPhoneNumber: Dispatch<SetStateAction<string>>
  setSignUpPhoneCountryCode: Dispatch<SetStateAction<number>>
}
export const PhoneForm = ({ setJoinStep, setSignUpPhoneNumber, setSignUpPhoneCountryCode }: PhoneSignUpProp) => {
  const { t } = useTranslation("authentication")
  const [isValid, setValid] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [checkPhoneNumberAvailable, { loading: phoneNumberAvailableLoading }] = useGetPhoneNumberAvailableLazyQuery()
  const [sendVerifyPhoneOtp] = useSendVerifyPhoneOtpMutation()
  const [phoneNumber, setPhoneNumber] = useState("")
  const [phoneCountryCode, setPhoneCountryCode] = useState("")
  const phoneWithoutCountry = phoneNumber.substring(phoneCountryCode.length)

  const validatePhoneNumberDebounce = useDebounce(validatePhoneNumberAvailability, 1000)
  const handlePhoneNumber = (phone: string, country: unknown | CountryData) => {
    const countryCode = (country as CountryData).dialCode
    setValid(false)
    setErrorMessage("")
    setPhoneNumber(phone)
    setPhoneCountryCode(countryCode)
    validatePhoneNumberDebounce({
      setValid,
      setErrorMessage,
      checkPhoneNumberAvailable,
      phone,
      country,
    })
  }

  const submit = async (e: React.MouseEvent<Element, MouseEvent>) => {
    e.preventDefault()
    if (process.env.NEXT_PUBLIC_ENV === "production" && typeof window !== "undefined") {
      ReactGA.event({
        category: "User",
        action: "get started",
      })
    }
    await sendVerifyPhoneOtp({
      variables: {
        phoneNumber: phoneWithoutCountry,
        phoneCountryCode: Number(phoneCountryCode),
      },
    })
    setSignUpPhoneNumber(phoneWithoutCountry)
    setSignUpPhoneCountryCode(Number(phoneCountryCode))
    setJoinStep(JoinStep.VerifyPhone)
  }
  return (
    <form id="signupForm" tw="relative">
      <PhoneNumberInput
        label={t("join.input_phone_label")}
        inputValue={phoneNumber}
        handleChange={handlePhoneNumber}
        error={errorMessage}
        loading={phoneNumberAvailableLoading}
        autoFocus={true}
      />
      <p tw="text-md font-bold text-center pb-[19px]">{t("join.info_phone")}</p>
      <p tw="text-xs font-light text-center pb-[19px]">{t("join.notification_disclaimer")}</p>
      <Button
        dataTestId="signup-button"
        action={t("join.next")}
        twStyle={tw`w-full`}
        onClickAsync={submit}
        isDisabled={!isValid}
      />
    </form>
  )
}
